import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import SelfCareInvoicesMain from './SelfCareInvoicesMain';
import InvoiceLoginRedirect from './Partials/InvoiceLoginRedirect';

const SelfCareAuthSwitch = (props) => {

  const loginObj = {
    loginType: 'extendedOtp', // extendedOtp, otp
    extendedOtp: { contact: false }
  };

  const renderComponentBasedOnLoginType = () => {
    if (loginObj.loginType === 'otp' || loginObj.loginType.toUpperCase() === 'NEWOTP' || loginObj.loginType.toUpperCase() == 'OTPSUBSCRIBER') {
      return <InvoiceLoginRedirect blockData={props.iContent} />;
    } else if (loginObj.loginType === 'fullIdentification' || loginObj.loginType === 'extendedOtp') {
      return <SelfCareInvoicesMain blockData={props.iContent} loginObj={loginObj} />;
    }
    return null;
  };
  return (
    <div>
      {renderComponentBasedOnLoginType()}
    </div>
  );
};

export default SelfCareAuthSwitch;
